var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "flex flex-grow flex-col items-center justify-center w-full h-full"
    },
    [
      _c("BaseIcon", {
        staticClass: "w-48 h-48 mb-4",
        attrs: { name: "media-kraken-confused" }
      }),
      _c("h2", { staticClass: "text-2xl font-semibold mb-4" }, [
        _vm._v(" Unsupported Browser ")
      ]),
      _c(
        "p",
        { staticClass: "text-gray-800 text-center leading-relaxed mb-1" },
        [
          _vm._v(
            " Unfortunately, this browser doesn't support IndexedDB which is necessary for Media Kraken to run. "
          )
        ]
      ),
      _vm.isFirefox
        ? _c(
            "p",
            { staticClass: "text-gray-800 text-center leading-relaxed mb-2" },
            [
              _vm._v(
                " Are you using Firefox in private browsing mode? This is a "
              ),
              _c(
                "BaseLink",
                {
                  attrs: {
                    url: "https://bugzilla.mozilla.org/show_bug.cgi?id=1639542"
                  }
                },
                [_vm._v(" known bug ")]
              ),
              _vm._v(". ")
            ],
            1
          )
        : _vm._e(),
      _c(
        "BaseLink",
        { attrs: { url: "https://caniuse.com/#feat=indexeddb" } },
        [_vm._v(" Find a compatible browser ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }